module.exports = __webpack_public_path__ + "static/media/abacus.2f19132a.svg";